const AVATAR_COLORS = ['#e9b8a8', '#57ad91', '#f7f5ad', '#fec925']

export const WHOSE_MINE = 'me'
export const WHOSE_MEMBER = 'member'
export const WHOSE_SOMEONE = 'someone'

export const CREDITED_NAME_MAX = 100

export const firstName = (fullname) => (fullname || '').trim().split(/\s+/)[0] || ''

const CHOICES = [
  { key: WHOSE_MINE, label: 'Mine' },
  { key: WHOSE_MEMBER, label: 'A family member' },
  { key: WHOSE_SOMEONE, label: 'Someone not on Morsel' },
]

// "Whose recipe is this?" Mine (the default), a family member on Morsel (the recipe
// becomes theirs), or someone who isn't on Morsel, like Grandma Rose (credited by name).
// value: { recipe_for, for_user_id, credited_name }
const WhoseRecipePicker = ({ value, onChange, members = [], onlyMembers = false }) => {
  const choice = value?.recipe_for || WHOSE_MINE
  const choices = onlyMembers ? CHOICES.filter(({ key }) => key === WHOSE_MEMBER) : CHOICES
  const set = (changes) => onChange({ ...value, ...changes })

  return (
    <div className="whosePicker">
      <div className="recipeCategoryChips" role="radiogroup" aria-label="Whose recipe is this?">
        {choices.map(({ key, label }) => (
          <label key={key} className={`recipeCategoryChip ${choice === key ? 'selected' : ''}`}>
            <input
              type="radio"
              name="recipe_for"
              value={key}
              checked={choice === key}
              onChange={() => set({ recipe_for: key })}
            />
            {label}
          </label>
        ))}
      </div>

      {choice === WHOSE_MEMBER &&
        (members.length ? (
          <>
            <p className="whosePickerHint">
              It becomes their recipe, with their name on it. You can still help with edits.
            </p>
            <div className="familyPicker" role="radiogroup" aria-label="Family member">
              {members.map(({ id, fullname, avatar }, index) => {
                const isOn = value?.for_user_id === id
                return (
                  <label key={id} className={`familyPickerItem ${isOn ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="for_user_id"
                      checked={isOn}
                      onChange={() => set({ for_user_id: id })}
                    />
                    <span
                      className="familyPickerAvatar"
                      style={{ backgroundColor: AVATAR_COLORS[index % AVATAR_COLORS.length] }}
                      aria-hidden="true"
                    >
                      {avatar ? (
                        <img src={avatar} alt="" className="whosePickerPhoto" />
                      ) : (
                        (fullname || '?').trim().charAt(0).toUpperCase()
                      )}
                    </span>
                    <span className="familyPickerName">{fullname}</span>
                    <span className="familyPickerCheck" aria-hidden="true">
                      {isOn ? '✓' : ''}
                    </span>
                  </label>
                )
              })}
            </div>
          </>
        ) : (
          <p className="familyPickerEmpty">
            Nobody else is in your family groups yet. Invite them first, or pick "Someone not on
            Morsel".
          </p>
        ))}

      {choice === WHOSE_SOMEONE && (
        <div className="formField">
          <label className="formLabel" htmlFor="recipeCreditedName">
            Their name
          </label>
          <input
            id="recipeCreditedName"
            type="text"
            className="form-control inputRecipeSource whosePickerName"
            placeholder="Grandma Rose"
            maxLength={CREDITED_NAME_MAX}
            value={value?.credited_name || ''}
            onChange={(e) => set({ credited_name: e.target.value })}
          />
          <p className="whosePickerHint">We'll show it as their recipe, added by you.</p>
        </div>
      )}
    </div>
  )
}

export default WhoseRecipePicker
